import { Component, computed, EventEmitter, inject, input, Input, InputSignal, Output } from '@angular/core';

import { Accessible } from '../../../../shared/mixins/accessible.mixin';
import {
  LiquidViewerIndex,
  LiquidViewerIndexItem,
  LiquidViewerIndexParagraph
} from '../../../liquid-viewer.models';
import { LiquidViewerIndexService } from 'src/index/services.index';


@Component({
  selector: 'meta-liquid-index',
  templateUrl: './liquid-index.component.html',
  styleUrls: ['./liquid-index.component.css'],
})
export class LiquidIndexComponent extends Accessible {
  liquidViewerIndexService = inject(LiquidViewerIndexService);

  @Input() override verticalNavSelector = 'button:not([aria-selected="false"]), a';
  @Input() override horizontalNavSelector = 'button[role="tab"]';

  $indexInput: InputSignal<LiquidViewerIndex> = input.required({ alias: 'index' });
  $currentIndexItemId: InputSignal<string> = input.required({ alias: 'currentIndexItemId' });

  $index = computed(() => {
    if (this.$currentIndexItemId() && this.$indexInput()) {
      return this.expandParentIndexItem(this.$indexInput(), this.$currentIndexItemId());
    }
    return this.$indexInput();
  })

  @Output() doClose = new EventEmitter();
  @Output() indexItemClicked = new EventEmitter<LiquidViewerIndexItem | LiquidViewerIndexParagraph>();

  selectedTab: string = "index";

  $tabList = computed(() => {
    const tabList = [
      {
        id: "index",
        label: "Index",
        visible: true,
      },
      {
        id: "attachments",
        label: "Attachments",
        visible: false,
      },
      {
        id: "events",
        label: "Events",
        visible: false,
      }
    ];
    return tabList;
  });

  expandParentIndexItem(index: LiquidViewerIndex, id: string) {
    index.items.forEach(item => {
      if (item.id === id) {
        item.expanded = true;
        return;
      }

      if (item.children) {
        item.expanded = item.children.findIndex(child => {
          if (child.id === id) {
            child.expanded = true;
            return true;
          }

          const findInChildrenResult = child.children?.find(c => c.id === id);
          if (findInChildrenResult) {
            child.expanded = true;
            findInChildrenResult.expanded = true;
            return true;
          }

          return false;
        }) !== -1;
      }
    })

    return index;
  }

  changeTab(tabId: string) {
    if (this.selectedTab === tabId) {
      return;
    }
    this.selectedTab = tabId;
  }

  toggleEntry(entry: LiquidViewerIndexItem) {
    if (this.itemCanBeExploded(entry)) {
      entry.expanded = !entry.expanded;
    }
  }

  itemCanBeExploded(item: LiquidViewerIndexItem) {
    return (item.children && item.children.length > 0)
      || (item.paragraphs && item.paragraphs.length > 0);
  }

  // Event Listeners
  onItemClicked(evt: any, item: LiquidViewerIndexItem | LiquidViewerIndexParagraph) {
    if (evt) {
      evt.stopPropagation();
      evt.preventDefault();
    }

    if (item.type === 'chapter' || item.type === 'page') {
      this.toggleEntry(item);
    }

    if (item.type === 'page' || item.type === 'paragraph') {      
      this.indexItemClicked.emit(item);
      this.onClose();
    }
  }

  onClose(): void {
    this.doClose.emit();
  }
}